"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var style_converter_1 = require("../../sis-tabular-report-options/converter/style-converter");
var cell_value_formatter_1 = require("../../sis-tabular-report-options/formatter/cell-value-formatter");
var cell_conditional_formatting_resolver_1 = require("../../sis-tabular-report-options/resolver/cell-conditional-formatting-resolver");
var cell_style_resolver_1 = require("../../sis-tabular-report-options/resolver/cell-style-resolver");
var simple_cell_style_resolver_1 = require("../../sis-tabular-report-options/resolver/simple-cell-style-resolver");
/**
 * Created by Hayk.Andriasyan on 7/11/2017.
 *
 * Convert standard report json to table rows for proper rendering.
 */
var ReportJsonConverter = /** @class */ (function () {
    function ReportJsonConverter(messages, reportViewStyles, categoryAndMeasurePaths, dataSetId, reportDto, localeService, formResolverService, pathHolderForms, localeInfo, measureTypes, metaCategories, defaultIconURL, categoryIconIdURLMap) {
        if (categoryIconIdURLMap === void 0) { categoryIconIdURLMap = new Map(); }
        this.messages = messages;
        this.reportViewStyles = reportViewStyles;
        this.categoryAndMeasurePaths = categoryAndMeasurePaths;
        this.dataSetId = dataSetId;
        this.reportDto = reportDto;
        this.localeService = localeService;
        this.formResolverService = formResolverService;
        this.pathHolderForms = pathHolderForms;
        this.localeInfo = localeInfo;
        this.measureTypes = measureTypes;
        this.metaCategories = metaCategories;
        this.defaultIconURL = defaultIconURL;
        this.categoryIconIdURLMap = categoryIconIdURLMap;
        this._metaColumnsBranchIndexToElementsList = new Map();
        this._cellValueFormatter = new cell_value_formatter_1.CellValueFormatter(this.reportViewStyles, this.localeService, this.localeInfo);
        this._cellStyleResolver = new cell_style_resolver_1.CellStyleResolver(new simple_cell_style_resolver_1.SimpleCellStyleResolver(this.reportViewStyles), new cell_conditional_formatting_resolver_1.CellConditionalFormattingStyleResolver(this.reportViewStyles));
        this.rowNumberingCounter = [];
        this.rowCategoryNumberingEnableMap = new Map();
        this.collectRowCategoriesNumberingFormat();
    }
    /**
     * Process each table cell value depending on its {@link MeasurePathType}, connected {@link MetaCategory},
     * view option {@link ReportElementViewType}.
     * @param value
     * @param measureTypeObject
     * @param columnBranchIndex
     * @param languageId
     * @private
     * @return string|TableCellElementValueModel[]
     */
    ReportJsonConverter.prototype.processCellValue = function (value, measureTypeObject, columnBranchIndex, languageId, localeInfo) {
        var _this = this;
        if (value === null) {
            return '';
        }
        var measureType = measureTypeObject['measureType'];
        // If the measure type is boolean, then replace it to 'yes'/'no' messages respectively.
        if (measureTypeObject && measureType === idm_dataset_service_client_js_1.MeasurePathType.BOOLEAN) {
            if (Boolean(value)) {
                return this.messages.get('boolean_measure_value_true');
            }
            else {
                return this.messages.get('boolean_measure_value_false');
            }
        }
        // if column is category element and has connected category
        if (measureTypeObject.hasOwnProperty('categoryPathHolderId')) {
            if (value) {
                try {
                    // in case of viewOption set to both icon and value or icon, we fetch values as JSON data
                    var values = JSON.parse(value);
                    var categoryPathHolderId = measureTypeObject['categoryPathHolderId'];
                    var categoryPathObject = this.categoryAndMeasurePaths.categoryPaths.get(categoryPathHolderId);
                    var categoryName_1 = categoryPathObject.metaCategoryId.systemName;
                    var metaCategory = this.metaCategories.get(categoryName_1);
                    var columnStyle = this.reportViewStyles
                        .columnBranchStylesDto && this.reportViewStyles
                        .columnBranchStylesDto[columnBranchIndex]
                        .categoriesStyle.get(categoryPathHolderId);
                    // if measure category has icons and view option includes icon , add icons to cell
                    if (this.defaultIconURL && metaCategory && metaCategory.getHasIcon() &&
                        columnStyle && columnStyle.view !== idm_report_export_service_client_js_1.ReportElementViewType.ONLY_VALUE) {
                        var isBothIconAndValueNeeded_1 = (columnStyle.view === idm_report_export_service_client_js_1.ReportElementViewType.BOTH_ICON_AND_VALUE);
                        // If category has icons, return collection of TableCellElementValueModel, which has formatted value and iconPath
                        return values.filter(function (valueItem) { return valueItem.name && valueItem.id; }).map(function (valueItem) {
                            var formattedValue = _this._cellValueFormatter.formatValue(valueItem.name, columnBranchIndex, languageId, measureType, measureTypeObject, localeInfo);
                            var cellValue = {};
                            if (valueItem.id && formattedValue) {
                                cellValue.iconPath = _this.categoryIconIdURLMap.get(categoryName_1 + "/" + valueItem.id) || _this.defaultIconURL;
                            }
                            if (formattedValue && isBothIconAndValueNeeded_1) {
                                cellValue.value = formattedValue;
                            }
                            return cellValue;
                        });
                    }
                    else {
                        // joins all formatted values into one string
                        return values
                            .map(function (valueItem) {
                            return _this._cellValueFormatter.formatValue(valueItem.name, columnBranchIndex, languageId, measureType, measureTypeObject, localeInfo);
                        })
                            .join('; ');
                    }
                }
                catch (error) {
                    // catch JSON parse error and process value as string
                    return this._cellValueFormatter.formatValue(value, columnBranchIndex, languageId, measureType, measureTypeObject, localeInfo);
                }
            }
        }
        else {
            return this._cellValueFormatter.formatValue(value, columnBranchIndex, languageId, measureType, measureTypeObject, localeInfo);
        }
        return value;
    };
    /**
     * Creates table view head. Each table head row index corresponds to head row level.
     * Each row contains collection of {@link TableHeadElementModel}. First element in each row
     * can be row grouping element if table has row grouping. Each element in row can be column
     * grouping element if table has column grouping.
     * @param columnGroupingValues
     * @param columnRootDto
     * @param categoryAndMeasurePaths
     * @param languageId
     * @param rowGroupingTitle
     * @return Array<Array<TableHeadElementModel>>
     */
    ReportJsonConverter.prototype.createTableHead = function (columnGroupingValues, columnRootDto, categoryAndMeasurePaths, languageId, rowGroupingTitle) {
        this._metaColumnsBranchIndexToElementsList = new Map();
        this.collectMetaColumnsTree(columnRootDto.children, [], 0);
        var depth = this.calculateDepth({ values: columnGroupingValues }) - 1;
        var tableHead = new Array(depth);
        var _loop_1 = function (level) {
            var values = this_1.getNodesByLevel({ values: columnGroupingValues }, level);
            tableHead[level] = new Array(values.length);
            for (var j = 0; j < values.length; j++) {
                var node = values[j];
                var branchIndex = +(values[j].branchIndex || 0);
                var columnBranchElements = this_1._metaColumnsBranchIndexToElementsList.get(branchIndex);
                var name_1 = void 0;
                if (values[j].values) {
                    if (columnBranchElements[level] instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                        name_1 = this_1._cellValueFormatter.getColumnCategoryTitle(values[j].name, branchIndex, columnBranchElements[level].categoryElementDto.categoryPathHolderId, languageId);
                    }
                    else {
                        name_1 = this_1._cellValueFormatter.getColumnMeasureTitle(values[j].name, branchIndex, languageId);
                    }
                }
                else {
                    var elementName = this_1.getElementName(branchIndex, categoryAndMeasurePaths, columnBranchElements[level], languageId);
                    var hasOtherMeasureElement = columnBranchElements.filter(function (value, index) {
                        return index !== level && value instanceof idm_reporting_service_client_js_1.ColumnMeasureDto;
                    }).length > 0;
                    var usePathName = !hasOtherMeasureElement;
                    name_1 = usePathName ? elementName : values[j].name;
                }
                var measureTypeObject = this_1.measureTypes.get(branchIndex);
                tableHead[level][j] = {
                    colSpan: this_1.getColSpan(node),
                    rowSpan: this_1.getRowSpan(node, level, depth),
                    name: name_1,
                    measureType: measureTypeObject.measureType,
                    branchIndex: branchIndex,
                    isRowGrouping: false,
                    reference: this_1.getElementReference(branchIndex, columnBranchElements[level], languageId)
                };
                if (measureTypeObject.hasOwnProperty('categoryPathHolderId') && level === depth - 1 && this_1.reportViewStyles
                    .columnBranchStylesDto) {
                    tableHead[level][j].viewOption = this_1.reportViewStyles
                        .columnBranchStylesDto[branchIndex]
                        .categoriesStyle.get(measureTypeObject.categoryPathHolderId).view;
                }
            }
        };
        var this_1 = this;
        for (var level = 0; level < depth; level++) {
            _loop_1(level);
        }
        if (rowGroupingTitle) {
            var rowGroupingColumn = {
                colSpan: 1,
                rowSpan: depth,
                name: rowGroupingTitle,
                width: this.getRowGroupingCaptionWidth(),
                isRowGrouping: true,
                reference: ''
            };
            if (tableHead[0]) {
                tableHead[0].unshift(rowGroupingColumn);
            }
            else {
                tableHead[0] = [rowGroupingColumn];
            }
        }
        return tableHead;
    };
    /**
     * Creates html column groups for table proper rendering and stores column width, branchIndex and viewOption.
     * @param columnBranchIndexes
     * @return Array<TableHeadColGroup>
     */
    ReportJsonConverter.prototype.getColGroups = function (columnBranchIndexes) {
        var _this = this;
        return columnBranchIndexes.map(function (branchIndex) {
            var elementsList = _this._metaColumnsBranchIndexToElementsList.get(branchIndex);
            var measureTypeObject = _this.measureTypes.get(branchIndex);
            return {
                width: _this.getColumnHeaderWidth(branchIndex, elementsList[elementsList.length - 1]),
                branchIndex: branchIndex,
                viewOption: measureTypeObject.hasOwnProperty('categoryPathHolderId') && _this.reportViewStyles
                    .columnBranchStylesDto ? _this.reportViewStyles
                    .columnBranchStylesDto[branchIndex]
                    .categoriesStyle.get(measureTypeObject.categoryPathHolderId).view : null
            };
        });
    };
    ReportJsonConverter.prototype.getNodesByLevel = function (tree, levelIndex) {
        if (levelIndex === 0) {
            return tree.values ? tree.values : [];
        }
        var count = [];
        if (tree.values) {
            for (var i = 0; i < tree.values.length; i++) {
                var items = this.getNodesByLevel(tree.values[i], levelIndex - 1);
                for (var k = 0; k < items.length; k++) {
                    count.push(items[k]);
                }
            }
        }
        return count;
    };
    ReportJsonConverter.prototype.calculateDepth = function (tree) {
        var depth = 0;
        if (tree.values) {
            for (var i = 0; i < tree.values.length; i++) {
                var childDepth = this.calculateDepth(tree.values[i]);
                if (childDepth > depth) {
                    depth = childDepth;
                }
            }
        }
        return depth + 1;
    };
    ReportJsonConverter.prototype.getColSpan = function (tree) {
        if (!tree.values || tree.values.length === 0) {
            return 1;
        }
        var colSpan = 0;
        for (var _i = 0, _a = tree.values; _i < _a.length; _i++) {
            var child = _a[_i];
            colSpan += this.getColSpan(child);
        }
        return colSpan;
    };
    ReportJsonConverter.prototype.getRowSpan = function (tree, level, depth) {
        if (tree.values && tree.values.length > 0) {
            return 1;
        }
        return depth - level;
    };
    /**
     * Collect map with key:branchIndex and  value:branchElementsList
     * @param elements
     * @param parents
     * @param branchIterator
     */
    ReportJsonConverter.prototype.collectMetaColumnsTree = function (elements, parents, branchIterator) {
        var this0 = this;
        for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
            var element = elements_1[_i];
            var branchElements = Array.from(parents);
            branchElements.push(element);
            if (element.children.length > 0) {
                branchIterator = this0.collectMetaColumnsTree(element.children, branchElements, branchIterator);
            }
            else {
                this._metaColumnsBranchIndexToElementsList.set(branchIterator, branchElements);
                branchIterator++;
            }
        }
        return branchIterator;
    };
    /**
     * Convert report data to table row models, which is convenient to render table.
     * Formats all row values and names, set formatting, width, total styles.
     * @param rowGrouping
     * @param columnBranchIndexes
     * @param indexToMeasureType
     * @param languageId
     * @param localeInfo
     * @return Array<TableRowElementModel> rows with formatted values and some additional data for proper rendering
     */
    ReportJsonConverter.prototype.getTableData = function (rowGrouping, columnBranchIndexes, indexToMeasureType, languageId, localeInfo) {
        var _this = this;
        var tableRows = [];
        var rowBranches = this.getRowBranches();
        if (rowGrouping.length > 0) {
            var values = rowGrouping[0].values;
            if (rowGrouping[0].rowCategories.length > 0) {
                for (var i = 0; i < rowGrouping.length; i++) {
                    var rowCategories = rowGrouping[i].rowCategories;
                    var rowCategoriesLength = rowCategories.length;
                    var matchCount = this.getRowsMatchCount(rowGrouping, i);
                    var isTotalBefore = false;
                    for (var j = matchCount; j < rowCategoriesLength; j++) {
                        var isGrantTotalBefore = (j === 0 && i === 0) && rowCategories[j].totalType === 'BEFORE';
                        if (!isGrantTotalBefore && rowCategories[j].totalType === 'BEFORE') {
                            isTotalBefore = true;
                            break;
                        }
                        var tableRow = this.createTableRowFromRowGrouping(rowGrouping[i], j);
                        tableRow.styles = this.getRowStyles(rowBranches, tableRow);
                        tableRow.url = this.getRowCategoryLinkIfClickable(rowBranches, tableRow);
                        tableRow.icon = this.getRowCategoryIconPathIfHasIcon(rowBranches, tableRow);
                        tableRows.push(tableRow);
                        if (rowCategories[j].isTotal) {
                            break;
                        }
                    }
                    tableRows[tableRows.length - 1].values = rowGrouping[i].values.slice();
                    tableRows[tableRows.length - 1].isTotalBefore = isTotalBefore;
                }
                tableRows.forEach(function (row) {
                    row.values = row.values.map(function (value, index) {
                        return {
                            styles: _this.getCellStyles(rowBranches, row, columnBranchIndexes[index], index, row.values),
                            value: _this.processCellValue(value, indexToMeasureType.get(columnBranchIndexes[index]), columnBranchIndexes[index], languageId, localeInfo),
                            columnBranchIndex: columnBranchIndexes[index]
                        };
                    });
                    row.isNumberingEnabled = !row.isTotal ? _this.checkIsNumberingEnabledForRow(rowBranches, row) : null;
                    row.numberingLevel = !row.isTotal ? _this.calculateRowNumber(row.isNumberingEnabled, row.level) : null;
                });
            }
            else if (values.length > 0) {
                var tableRow = {};
                tableRow.values = values.map(function (value, index) {
                    return {
                        value: _this.processCellValue(value, indexToMeasureType.get(columnBranchIndexes[index]), columnBranchIndexes[index], languageId, localeInfo),
                        styles: _this.getCellStylesWithoutRowGrouping(columnBranchIndexes[index], value),
                        columnBranchIndex: columnBranchIndexes[index]
                    };
                });
                tableRows.push(tableRow);
            }
        }
        return tableRows;
    };
    ReportJsonConverter.prototype.getRowsMatchCount = function (rowGrouping, index) {
        var matchCount = 0;
        if (index > 0) {
            var rowCategories = rowGrouping[index].rowCategories;
            var previousRowCategories = rowGrouping[index - 1].rowCategories;
            var rowCategoriesLength = rowCategories.length;
            for (var j = 0; j < Math.min(previousRowCategories.length, rowCategoriesLength); j++) {
                /**
                 * example1
                 * previousRowCategories[j] [2,1,10,1], previousRowCategories.branchIndex [0,0,0,0]
                 * rowCategories[j].id [2,1,10,2], rowCategories.branchIndex [0,0,0,0]
                 *
                 * match count will be 3
                 *
                 * example2
                 *
                 * previousRowCategories[j] [2,1,10,1], previousRowBranchIndex [0,0,0,0]
                 * rowCategories[j].id [2,1,10,2], rowCategories.branchIndex [0,0,1,1]
                 *
                 * match count will be 2
                 */
                // tslint:disable:no-bitwise
                if (previousRowCategories[j].id !== rowCategories[j].id || (previousRowCategories[j].isTotal ^ rowCategories[j].isTotal) ||
                    previousRowCategories[j].branchIndex !== rowCategories[j].branchIndex) {
                    break;
                }
                // tslint:enable:no-bitwise
                matchCount++;
            }
        }
        return matchCount;
    };
    /**
     * Creates table row element
     * @param rowGrouping
     * @param index
     * @private
     * @return TableRowElementModel
     */
    ReportJsonConverter.prototype.createTableRowFromRowGrouping = function (rowGrouping, index) {
        return {
            name: this.changeUnspecifiedIfNeeded(rowGrouping.rowCategories[index]),
            instanceId: rowGrouping.rowCategories[index].id,
            level: index,
            branchIndex: rowGrouping.rowCategories[index].branchIndex,
            isTotal: rowGrouping.rowCategories[index].isTotal,
            values: new Array(rowGrouping.values.length).fill(null)
        };
    };
    ReportJsonConverter.prototype.getCellStyles = function (rowBranches, row, columnBranchIndex, cellIndex, rowValues) {
        if (rowBranches[0].length !== 0) {
            var rowBranchIndex = row.branchIndex;
            var rowLevel = row.level;
            var rowCategoryPathHolderId = rowBranches[rowBranchIndex][rowLevel] !== undefined ?
                rowBranches[rowBranchIndex][rowLevel].categoryElementDto.categoryPathHolderId : -1;
            var textStyleDto = this._cellStyleResolver.resolveValueCellStyle(rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex, rowValues, cellIndex, new Map().set(columnBranchIndex, columnBranchIndex));
            if (textStyleDto.align === undefined) {
                var measureType = this.measureTypes.get(columnBranchIndex).measureType;
                if (measureType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER || measureType === idm_dataset_service_client_js_1.MeasurePathType.MONEY) {
                    textStyleDto.align = idm_report_export_service_client_js_1.Align.RIGHT;
                }
            }
            var styles = style_converter_1.StyleConverter.covert(textStyleDto);
            return row.isTotalBefore ? __assign({}, styles, { 'font-weight': 'bold' }) : styles;
        }
    };
    ReportJsonConverter.prototype.getCellStylesWithoutRowGrouping = function (columnBranchIndex, value) {
        var textStyleDto = this._cellStyleResolver.resolveValueCellStyleWithoutRowGrouping(columnBranchIndex, value, new Map().set(columnBranchIndex, columnBranchIndex));
        if (textStyleDto.align === undefined) {
            var measureType = this.measureTypes.get(columnBranchIndex).measureType;
            if (measureType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER || measureType === idm_dataset_service_client_js_1.MeasurePathType.MONEY) {
                textStyleDto.align = idm_report_export_service_client_js_1.Align.RIGHT;
            }
        }
        return style_converter_1.StyleConverter.covert(textStyleDto);
    };
    ReportJsonConverter.prototype.getRowStyles = function (rowBranches, row) {
        if (rowBranches[0].length !== 0) {
            var rowBranchIndex = row.branchIndex;
            var rowLevel = row.level;
            var rowCategoryPathHolderId = rowBranches[rowBranchIndex][rowLevel] !== undefined ?
                rowBranches[rowBranchIndex][rowLevel].categoryElementDto.categoryPathHolderId : -1;
            return style_converter_1.StyleConverter.covert(this._cellStyleResolver.resolveRowCategoryItemStyle(rowBranchIndex, rowCategoryPathHolderId, row.values));
        }
    };
    ReportJsonConverter.prototype.getRowBranches = function () {
        var tree = [];
        var stack = [];
        this.createRowBranches(tree, this.reportDto.rowRootDto.children, stack);
        return tree;
    };
    ReportJsonConverter.prototype.createRowBranches = function (rowBranches, rowElements, branchElements) {
        if (rowElements == null || rowElements.length === 0) {
            var branch = [];
            rowBranches.push(branch);
            for (var _i = 0, branchElements_1 = branchElements; _i < branchElements_1.length; _i++) {
                var branchElement = branchElements_1[_i];
                branch.push(branchElement);
            }
        }
        else {
            for (var _a = 0, rowElements_1 = rowElements; _a < rowElements_1.length; _a++) {
                var rowCategoryElement = rowElements_1[_a];
                branchElements.push(rowCategoryElement);
                this.createRowBranches(rowBranches, rowCategoryElement.children, branchElements);
                branchElements.pop();
            }
        }
    };
    /**
     * Returns form link if row category is clickable
     * @param rowBranches
     * @param row
     */
    ReportJsonConverter.prototype.getRowCategoryLinkIfClickable = function (rowBranches, row) {
        if (rowBranches[0].length > 0) {
            var categoryPath = rowBranches[row.branchIndex][row.level];
            if (categoryPath) {
                var pathForms = this.pathHolderForms.pathForms;
                var categoryPathHolderId = categoryPath.categoryElementDto.categoryPathHolderId;
                var categoryPathObject_1 = this.categoryAndMeasurePaths.categoryPaths.get(categoryPathHolderId);
                var categoryName = categoryPathObject_1.metaCategoryId.systemName;
                var pathFormNames = pathForms.get(categoryPathHolderId) ?
                    pathForms.get(categoryPathHolderId)['VIEW'] : '';
                if (pathFormNames) {
                    var instanceId = row.instanceId;
                    if (instanceId != null) {
                        var formName = pathFormNames && pathFormNames[0] ? pathFormNames[0].split(':')[0] : '';
                        var formId = pathFormNames && pathFormNames[0] ? Number(pathFormNames[0].split(':')[1]) : 0;
                        return this.formResolverService.getUrlForViewDeForm(categoryName, formName, instanceId, formId)
                            .then(function (url) { return categoryPathObject_1.pathSource === idm_dataset_service_client_js_1.PathSource.INDICATORS ? 'me/indicator/portfolio/' + url : url; });
                    }
                }
            }
        }
        return Promise.resolve(null);
    };
    /**
     * Return icon if row category has icon
     * @param rowBranches
     * @param row
     * @return TableRowElementIconModel
     */
    ReportJsonConverter.prototype.getRowCategoryIconPathIfHasIcon = function (rowBranches, row) {
        var categoryPath = rowBranches[row.branchIndex][row.level];
        if (categoryPath && this.defaultIconURL) {
            var categoryPathHolderId = categoryPath.categoryElementDto.categoryPathHolderId;
            var categoryPathObject = this.categoryAndMeasurePaths.categoryPaths.get(categoryPathHolderId);
            var categoryName = categoryPathObject.metaCategoryId.systemName;
            var metaCategory = this.metaCategories.get(categoryName);
            var instanceId = row.instanceId;
            if (instanceId != null && metaCategory && metaCategory.getHasIcon() && this.reportViewStyles.rowBranchStylesDto) {
                var rowStyle = this.reportViewStyles
                    .rowBranchStylesDto[row.branchIndex]
                    .categoriesStyle.get(categoryPathHolderId);
                var iconPath = this.categoryIconIdURLMap.get(categoryName + "/" + instanceId) || this.defaultIconURL;
                return {
                    iconPath: iconPath,
                    viewOption: rowStyle.view
                };
            }
        }
        return null;
    };
    ReportJsonConverter.prototype.getElementName = function (branchIndex, categoryAndMeasurePaths, element, languageId) {
        var name;
        var title;
        if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            name = categoryAndMeasurePaths.measurePaths.get(element.measurePathHolderId).name.get(languageId);
            title = this._cellValueFormatter.getColumnMeasureTitle(name, branchIndex, languageId);
        }
        else {
            name = categoryAndMeasurePaths.categoryPaths.get(element.categoryElementDto.categoryPathHolderId).name.get(languageId);
            title = this._cellValueFormatter.getColumnCategoryTitle(name, branchIndex, element.categoryElementDto.categoryPathHolderId, languageId);
        }
        return title ? title : name;
    };
    ReportJsonConverter.prototype.getElementReference = function (branchIndex, element, languageId) {
        var reference;
        if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[branchIndex]) {
                if (this.reportViewStyles.columnBranchStylesDto[branchIndex].measureStyle) {
                    var referenceDto = this.reportViewStyles.columnBranchStylesDto[branchIndex].measureStyle.reference;
                    if (referenceDto) {
                        reference = referenceDto.referenceNumber.text.getValue(languageId);
                    }
                }
            }
            return reference;
        }
        else {
            if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[branchIndex]) {
                var columnCategoryPathHolderId = element.categoryElementDto.categoryPathHolderId;
                if (this.reportViewStyles.columnBranchStylesDto[branchIndex].categoriesStyle.get(columnCategoryPathHolderId)) {
                    var referenceDto = this.reportViewStyles.columnBranchStylesDto[branchIndex].categoriesStyle.get(columnCategoryPathHolderId).reference;
                    if (referenceDto) {
                        reference = referenceDto.referenceNumber.text.getValue(languageId);
                    }
                }
            }
            return reference;
        }
    };
    ReportJsonConverter.prototype.getRowGroupingCaptionWidth = function () {
        var resultWidth;
        if (this.reportViewStyles.rowBranchStylesDto && this.reportViewStyles.rowBranchStylesDto[0] && this.reportViewStyles.rowBranchStylesDto[0].categoriesStyle) {
            this.reportViewStyles.rowBranchStylesDto[0].categoriesStyle.forEach(function (style) {
                if (style.width) {
                    resultWidth = +style.width;
                }
            });
        }
        return resultWidth;
    };
    ReportJsonConverter.prototype.getColumnHeaderWidth = function (branchIndex, element) {
        var elementStyleDto;
        if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[branchIndex]) {
            var columnBranchStylesDto = this.reportViewStyles.columnBranchStylesDto[branchIndex];
            if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                if (columnBranchStylesDto.measureStyle) {
                    elementStyleDto = columnBranchStylesDto.measureStyle;
                }
            }
            else if (columnBranchStylesDto.categoriesStyle &&
                columnBranchStylesDto.categoriesStyle.get(element.categoryElementDto.categoryPathHolderId)) {
                elementStyleDto = columnBranchStylesDto.categoriesStyle.get(element.categoryElementDto.categoryPathHolderId);
            }
        }
        return elementStyleDto && elementStyleDto.width ? +elementStyleDto.width : null;
    };
    ReportJsonConverter.prototype.changeUnspecifiedIfNeeded = function (row) {
        var name = '';
        if (row.id === null && !row.isTotal) {
            name = this.messages.get('reporting.UNSPECIFIED');
        }
        else {
            row.name === null ? name = 'null' : name = row.name;
        }
        return name;
    };
    ReportJsonConverter.prototype.calculateRowNumber = function (rowNumberingEnabled, level) {
        this.rowNumberingCounter[level] === undefined && (this.rowNumberingCounter[level] = 0);
        if (level < this.rowNumberingCounter.length) {
            this.rowNumberingCounter[level + 1] = 0;
        }
        return rowNumberingEnabled ? ++this.rowNumberingCounter[level] : null;
    };
    ReportJsonConverter.prototype.collectRowCategoriesNumberingFormat = function () {
        var _this = this;
        this.reportViewStyles.rowBranchStylesDto.forEach(function (rowBranchStyle) {
            rowBranchStyle.categoriesStyle.forEach(function (categoryStyle, categoryPathHolderId) {
                var branchCategoryKey = rowBranchStyle.branchIndex + "_" + categoryPathHolderId;
                _this.rowCategoryNumberingEnableMap.set(branchCategoryKey, categoryStyle.numberingStyle !== null);
            });
        });
    };
    ReportJsonConverter.prototype.checkIsNumberingEnabledForRow = function (rowBranches, row) {
        var categoryPathHolderId = rowBranches[row.branchIndex][row.level]
            && rowBranches[row.branchIndex][row.level].categoryElementDto.categoryPathHolderId;
        if (!categoryPathHolderId && categoryPathHolderId != 0) {
            return null;
        }
        var branchCategoryKey = row.branchIndex + "_" + categoryPathHolderId;
        return this.rowCategoryNumberingEnableMap.get(branchCategoryKey);
    };
    return ReportJsonConverter;
}());
exports.ReportJsonConverter = ReportJsonConverter;
//# sourceMappingURL=report-json-converter.js.map